import React, { useState } from 'react';
import styled from 'styled-components';
import ScreenHalfContent from './ScreenHalfContent'
import Map from '../../../screens/Map/Map';
import useMobile from '../../../other/Hooks/useMobile';

type HalfScreenProps = {
  enter: boolean
  focusedScreen: '' | 'left' | 'right'
}

const ScreenRightContainer = styled.div`


  ${({ focusedScreen }: HalfScreenProps) => {
    switch (focusedScreen) {
      case 'left':
        return `
          width: 0%;
        `;
      case 'right':
        return `
          width: 100%;
        `;
      default:
        return `
          width: 50%;
        `;
    }
  }}
  height: 100%;
  position: absolute;
  top: 0;
  right: ${({ enter }: HalfScreenProps) => enter ? '0%' : '-50%'};
  z-index: 2;

  transition: all 1s ease-in-out;
`;

const MenuIconContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 15;
  padding: 15px;
  cursor: pointer;
`;

type Props = {
  backToSplit: any
  enter: boolean
  focusedScreen: 'left' | 'right' | ''
  setFocusedScreen: React.Dispatch<React.SetStateAction<"" | "left" | "right">>
}

const ScreenRight = ({ enter, focusedScreen, setFocusedScreen, backToSplit }: Props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useMobile()

  // useEffect(() => {
  //   (async () => {
  //     if (enter && focusedScreen === 'left') await setTimeout(() => setRemove(true), 1000)
  //     else setRemove(false)
  //   })()

  // }, [enter, focusedScreen])


  const handleMenuClick = () => {
    setMenuOpen(prev => !prev);
  };

  const changeScreen = () => {
    setFocusedScreen('left');
  };

  return (
    <ScreenRightContainer
      enter={enter}
      focusedScreen={focusedScreen}
      onClick={() => {
        if (isMobile && focusedScreen !== 'right') setFocusedScreen('right')
      }}
    >
      <Map
        changeScreen={() => changeScreen()}
        focused={focusedScreen === 'right'}
        backToSplit={backToSplit}
      />
      {focusedScreen === "" && !isMobile && <ScreenHalfContent
        key={`${enter}`}
        position='right'
        header={['EXPLORE THE', 'INTERACTIVE MAP']}
        body='Whether you’re a new or prospective student, we invite you to explore all of the facilities you’ll have access to within the training centre. Learn about each of our centre hotspots and their associated programs.'
      />
      }

    </ScreenRightContainer>
  );
};

export default ScreenRight;